// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-content {
    width: 83%;
    height: 35%;
    margin: 10px;
    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    align-items: center;
    justify-content: center;
    color:#200000;
    text-align: center;
    font-weight: 500;
    border:none;
    border-radius:10px;
    background-color:#F8ECD1;
    
}
.trainingCards .card{
  cursor: pointer;
}

.TCSPharma ,.card-content1:hover {
    width: 85%;
    height: 35%;
    margin: 10px;
    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 500;
    border:none;
    border-radius:10px;
    background-color:#962E2A;
    color:white;
    transform:scale(1.08);
}
.TCSPharma::after{
    content: '';
    position: absolute;
    left: 100%;
    top: 35%;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
	border-left: 12px solid #962E2A;
	border-bottom: 12px solid transparent;
    clear: both;
  }

.ITProcedures ,.card-content2:hover {
    width: 85%;
    height: 35%;
    margin: 10px;
    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 500;
    border:none;
    border-radius:10px;
    background-color:#28a745;
    color:white;
    transform:scale(1.07);
}
.ITProcedures::after{
    content: '';
    position: absolute;
    left: 100%;
    top: 35%;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
	border-left: 12px solid #28a745;
	border-bottom: 12px solid transparent;
    clear: both;
  }
.UsefulInfo, .card-content3:hover {
    width: 85%;
    height: 35%;
    margin: 10px;
    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 500;
    border:none;
    border-radius:10px;
    background-color:#219ebc ;
    color:white;
    transform:scale(1.07);
}
.UsefulInfo::after{
    content: '';
    position: absolute;
    left: 100%;
    top: 35%;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
	border-left: 12px solid #219ebc ;
	border-bottom: 12px solid transparent;
    clear: both;
  }
.Other, .card-content4:hover{
    width: 85%;
    height: 35%;
    margin: 10px;
    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 500;
    border:none;
    border-radius:10px;
    background-color:#ffd147;
    transform:scale(1.07);
}
.Other::after{
    content: '';
    position: absolute;
    left: 100%;
    top: 35%;
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
	border-left: 12px solid #ffd147;
	border-bottom: 12px solid transparent;
    clear: both;
  }
  .nav-outerdiv{
    display: inline-block;
    width: 30%;
    height: 100%;
    background-color: #F5F5F5;
    border-radius: 20px 0px 0px 20px ;
  }
  .nav-title{
    font-family: Merriweather Sans;
    font-weight: bold;
    margin: 20px;
  }
  .nav-innerdiv{
    display: flex;
    justify-content: center;
    align-items: center;
    height:70%;
  }
  .nav-card{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90%;
    align-items: center;
    justify-content: center;
  }
  

  `, "",{"version":3,"sources":["webpack://./src/components/modules/trainings/TrainingsNav.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2EAA2E;IAC3E,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,wBAAwB;;AAE5B;AACA;EACE,eAAe;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2EAA2E;IAC3E,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kCAAkC;CACrC,+BAA+B;CAC/B,qCAAqC;IAClC,WAAW;EACb;;AAEF;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2EAA2E;IAC3E,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kCAAkC;CACrC,+BAA+B;CAC/B,qCAAqC;IAClC,WAAW;EACb;AACF;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2EAA2E;IAC3E,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kCAAkC;CACrC,gCAAgC;CAChC,qCAAqC;IAClC,WAAW;EACb;AACF;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2EAA2E;IAC3E,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,kCAAkC;CACrC,+BAA+B;CAC/B,qCAAqC;IAClC,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;EACnC;EACA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB","sourcesContent":[".card-content {\n    width: 83%;\n    height: 35%;\n    margin: 10px;\n    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    align-items: center;\n    justify-content: center;\n    color:#200000;\n    text-align: center;\n    font-weight: 500;\n    border:none;\n    border-radius:10px;\n    background-color:#F8ECD1;\n    \n}\n.trainingCards .card{\n  cursor: pointer;\n}\n\n.TCSPharma ,.card-content1:hover {\n    width: 85%;\n    height: 35%;\n    margin: 10px;\n    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-weight: 500;\n    border:none;\n    border-radius:10px;\n    background-color:#962E2A;\n    color:white;\n    transform:scale(1.08);\n}\n.TCSPharma::after{\n    content: '';\n    position: absolute;\n    left: 100%;\n    top: 35%;\n    width: 0;\n    height: 0;\n    border-top: 12px solid transparent;\n\tborder-left: 12px solid #962E2A;\n\tborder-bottom: 12px solid transparent;\n    clear: both;\n  }\n\n.ITProcedures ,.card-content2:hover {\n    width: 85%;\n    height: 35%;\n    margin: 10px;\n    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-weight: 500;\n    border:none;\n    border-radius:10px;\n    background-color:#28a745;\n    color:white;\n    transform:scale(1.07);\n}\n.ITProcedures::after{\n    content: '';\n    position: absolute;\n    left: 100%;\n    top: 35%;\n    width: 0;\n    height: 0;\n    border-top: 12px solid transparent;\n\tborder-left: 12px solid #28a745;\n\tborder-bottom: 12px solid transparent;\n    clear: both;\n  }\n.UsefulInfo, .card-content3:hover {\n    width: 85%;\n    height: 35%;\n    margin: 10px;\n    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-weight: 500;\n    border:none;\n    border-radius:10px;\n    background-color:#219ebc ;\n    color:white;\n    transform:scale(1.07);\n}\n.UsefulInfo::after{\n    content: '';\n    position: absolute;\n    left: 100%;\n    top: 35%;\n    width: 0;\n    height: 0;\n    border-top: 12px solid transparent;\n\tborder-left: 12px solid #219ebc ;\n\tborder-bottom: 12px solid transparent;\n    clear: both;\n  }\n.Other, .card-content4:hover{\n    width: 85%;\n    height: 35%;\n    margin: 10px;\n    box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-weight: 500;\n    border:none;\n    border-radius:10px;\n    background-color:#ffd147;\n    transform:scale(1.07);\n}\n.Other::after{\n    content: '';\n    position: absolute;\n    left: 100%;\n    top: 35%;\n    width: 0;\n    height: 0;\n    border-top: 12px solid transparent;\n\tborder-left: 12px solid #ffd147;\n\tborder-bottom: 12px solid transparent;\n    clear: both;\n  }\n  .nav-outerdiv{\n    display: inline-block;\n    width: 30%;\n    height: 100%;\n    background-color: #F5F5F5;\n    border-radius: 20px 0px 0px 20px ;\n  }\n  .nav-title{\n    font-family: Merriweather Sans;\n    font-weight: bold;\n    margin: 20px;\n  }\n  .nav-innerdiv{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height:70%;\n  }\n  .nav-card{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 90%;\n    align-items: center;\n    justify-content: center;\n  }\n  \n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
